import React, { useState } from 'react'
import { Button } from 'antd'

import RequestHistoryButtonModal from './request-history-button-modal'
import { Id } from 'src/types'
import { useTranslation } from 'react-i18next'

interface RequestHistoryButtonProps {
  request_id: Id
  user_id: Id
}

export default function RequestHistoryButton({
  request_id,
  user_id
}: RequestHistoryButtonProps) {
  const [modalVisible, setModalVisible] = useState(false)

  const { t } = useTranslation()

  function toggle() {
    setModalVisible(visible => !visible)
  }

  return (
    <>
      <Button
        type="dashed"
        icon="history"
        onClick={() => {
          setModalVisible(true)
        }}
      >
        {t('web.request.history.title')}
      </Button>
      <RequestHistoryButtonModal
        modalVisible={modalVisible}
        request_id={request_id}
        toggle={toggle}
        user_id={user_id}
      />
    </>
  )
}
